export default "__VITE_ASSET__BzS_E0Wa__"